<template>
  <div class="def-tracking-click">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'DefTrackingClick',
  mounted() {
    document.addEventListener('click', this.handlerClick, true);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handlerClick, true);
  },
  methods: {
    handlerClick(e) {
      if (!e.target.closest('.def-tracking-click')) {
        this.$emit('close', e);
      }
    },
  },
};
</script>
